





































import { Component, Vue } from "vue-property-decorator"
import ButtonOne from "@/components/Buttons/ButtonOne.vue"
import ButtonTwo from "@/components/Buttons/ButtonTwo.vue"
import ButtonThree from "@/components/Buttons/ButtonThree.vue"
import ButtonFour from "@/components/Buttons/ButtonFour.vue"
import ButtonFive from "@/components/Buttons/ButtonFive.vue"
import ButtonSix from "@/components/Buttons/ButtonSix.vue"
import ButtonSeven from "@/components/Buttons/ButtonSeven.vue"
import * as Reveal from "@/assets/scripts/RevealOnScrollModule"
import * as ToggleContent from '@/assets/scripts/ToggleContentModule'
import ButtonEight from "@/components/Buttons/ButtonEight.vue"
import ButtonNine from "@/components/Buttons/ButtonNine.vue"

@Component({
    components: {
        ButtonOne,
        ButtonTwo,
        ButtonThree,
        ButtonFour,
        ButtonFive,
        ButtonSix,
        ButtonSeven,
        ButtonEight,
        ButtonNine
    }
})

export default class ButtonPage extends Vue {
    data() {
        return {
            PageTitle: "Button collection"
        }
    }
    mounted() {
        new Reveal.revealOnScrollModule()
        new ToggleContent.toggleContent()
    }
}
